import React from 'react';
import './Loading.styles.css';

export interface LoadingProps {
  size?: 'small' | 'medium' | 'large';
  text?: string;
  fullScreen?: boolean;
  overlay?: boolean;
  className?: string;
}

export const Loading: React.FC<LoadingProps> = ({
  size = 'medium',
  text,
  fullScreen = false,
  overlay = false,
  className = ''
}) => {
  const containerClass = [
    'loading-container',
    fullScreen && 'loading-fullscreen',
    overlay && 'loading-overlay',
    className
  ].filter(Boolean).join(' ');

  const spinnerClass = [
    'loading-spinner',
    `loading-${size}`
  ].join(' ');

  return (
    <div className={containerClass}>
      <div className="loading-content">
        <div className={spinnerClass}>
          <div className="loading-circle"></div>
        </div>
        {text && <div className="loading-text">{text}</div>}
      </div>
    </div>
  );
};